module.exports = __webpack_public_path__ + "static/media/darkblue-nodata.9ebd28e9.png";